import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer as RTC, Zoom } from 'react-toastify';
import { Store } from 'redux';
import { GlobalStyles, ReactDayPickerStyles, ToastStyles } from 'components';
import { AnalyticsProvider } from 'contexts/analytics';
import { FeatureFlagsProvider } from 'contexts/featureFlags';
import { FullStoryProvider } from 'contexts/fullstory';
import { SessionProvider } from 'contexts/session';
import { theme } from 'design';
import { AppRoutes } from 'routes/AppRoutes';
import { IStore } from 'store/types';
import './design/fonts/fonts.css';

interface IAppProps {
  store: Store<IStore>;
}

const App: React.FC<IAppProps> = ({ store }: IAppProps) => (
  <>
    <GlobalStyles />
    <ToastStyles />
    <ReactDayPickerStyles />
    <Provider store={store}>
      <FeatureFlagsProvider>
        <AnalyticsProvider>
          <FullStoryProvider>
            <SessionProvider>
              <RTC position="top-center" transition={Zoom} draggable={false} closeOnClick autoClose={theme.toast.timing} hideProgressBar />
              <AppRoutes />
            </SessionProvider>
          </FullStoryProvider>
        </AnalyticsProvider>
      </FeatureFlagsProvider>
    </Provider>
  </>
);

export default App;
